// extracted by mini-css-extract-plugin
export default {"country":"AddressDialog_country__2LLKy","submit":"AddressDialog_submit__ZmE8M"};